import { modifier } from "../modifiers";

modifier("downcase", (value) => value.toString().toLowerCase());
